module.exports = "/_next/static/images/yogoro_menu-0b701c384a1b54a805a9cf7de7923643.jpg";